import { useCallback, useEffect, useState } from "react";

import type NoSleep from "nosleep.js"; // import type only

export function useNoSleep() {
  const [noSleep, setNoSleep] = useState<NoSleep | null>(null);
  const [isEnabled, setIsEnabled] = useState(false);

  // Load NoSleep only in the browser
  useEffect(() => {
    if (typeof window !== "undefined") {
      import("nosleep.js").then(({ default: NoSleepClass }) => {
        setNoSleep(new NoSleepClass());
      });
    }
  }, []);

  const enable = useCallback(() => {
    if (noSleep) {
      noSleep.enable();
      setIsEnabled(true);
    }
  }, [noSleep]);

  const disable = useCallback(() => {
    if (noSleep) {
      noSleep.disable();
      setIsEnabled(false);
    }
  }, [noSleep]);

  useEffect(() => {
    return () => {
      if (isEnabled && noSleep) {
        noSleep.disable();
      }
    };
  }, [isEnabled, noSleep]);

  return { isEnabled, enable, disable };
}
